import { createClient } from "@supabase/supabase-js";
import { createClaudeShim } from "./supabaseStore.js";
import { bootTabwheel } from "./app.js";

var SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
var SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

var authLoading = document.getElementById("authLoading");
var authGate = document.getElementById("authGate");
var authWait = document.getElementById("authWait");
var authError = document.getElementById("authError");
var appRoot = document.getElementById("appRoot");
var googleBtn = document.getElementById("googleSignIn");

function showLoading(){ authLoading.hidden = false; authGate.hidden = true; authWait.hidden = true; appRoot.hidden = true; }
function showSignIn(msg){
  authLoading.hidden = true; authGate.hidden = false; authWait.hidden = true; appRoot.hidden = true;
  if(msg){ authError.textContent = msg; authError.hidden = false; } else { authError.hidden = true; }
}
/* signed in, but not let in yet (0005's sign-up gate): claim_workspace() returned null */
function showWait(email){
  authLoading.hidden = true; authGate.hidden = true; authWait.hidden = false; appRoot.hidden = true;
  document.getElementById("authWaitWho").textContent = email || "your Google account";
}
function showApp(){ authLoading.hidden = true; authGate.hidden = true; authWait.hidden = true; appRoot.hidden = false; }
function wait(ms){ return new Promise(function(res){ setTimeout(res, ms); }); }

/* A signed-out visitor to "/" (no session, and not mid-Google-sign-in) is better served
   by the marketing page than a bare sign-in button. `/?signin=1` (every "Sign in" link
   on the marketing pages) and the Google OAuth return (a "code" or "access_token"/"error"
   param this app never sets itself) both skip the bounce, so it can never loop. */
function wantsSignInDirectly(){
  if(/[?&]signin=1\b/.test(location.search)) return true;
  if(/[?&]code=/.test(location.search)) return true;
  if(/[#&]access_token=|[#&]error=/.test(location.hash)) return true;
  return false;
}

if(!SUPABASE_URL || !SUPABASE_KEY){
  showSignIn("Missing Supabase configuration. Copy app/.env.example to app/.env and fill in the project URL and publishable key, then rebuild.");
} else {
  var supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
  var booted = false;

  googleBtn.addEventListener("click", function(){
    authError.hidden = true;
    supabase.auth.signInWithOAuth({provider:"google", options:{redirectTo:window.location.origin}}).then(function(res){
      if(res.error) showSignIn(res.error.message);
    });
  });

  // resolveWorkspace → workspace id, or null when this account isn't let in yet.
  // The on-signup trigger (handle_new_user, 0001; gated by 0005) creates a
  // personal workspace when a user's row appears in auth.users. A brand-new
  // sign-in can briefly race it, so look a couple of times first. Then ask
  // claim_workspace() (0005): it returns the existing workspace, creates one if
  // sign-ups are open / the email was let in / the user is an admin, or returns
  // null ("invite-only for now"). Before 0005 is run that RPC doesn't exist
  // (PGRST202 / 404), so fall back to the old retry-then-error behaviour.
  function findWorkspace(){
    return supabase.from("workspaces").select("id").limit(1).maybeSingle().then(function(r){
      if(r.error) throw r.error;
      return r.data && r.data.id ? r.data.id : null;
    });
  }
  function legacyRetry(attempt){
    return findWorkspace().then(function(id){
      if(id) return id;
      if(attempt >= 8) throw new Error("No workspace found for this account yet.");
      return wait(500).then(function(){ return legacyRetry(attempt + 1); });
    });
  }
  function resolveWorkspace(attempt){
    return findWorkspace().then(function(id){
      if(id) return id;
      if(attempt < 2) return wait(400).then(function(){ return resolveWorkspace(attempt + 1); });
      return supabase.rpc("claim_workspace").then(function(r){
        if(!r.error) return r.data || null;
        if(r.error.code === "PGRST202" || r.status === 404) return legacyRetry(attempt);
        throw r.error;
      });
    });
  }

  function boot(session){
    if(booted) return; booted = true;
    showLoading();
    resolveWorkspace(0).then(function(workspaceId){
      if(!workspaceId){ booted = false; showWait(session.user && session.user.email); return; }
      window.claude = createClaudeShim({supabase:supabase, workspaceId:workspaceId, userId:session.user.id});
      showApp();
      bootTabwheel();
      checkAdmin();
    }).catch(function(err){
      booted = false;
      showSignIn("Couldn't set up your workspace: " + (err && err.message ? err.message : err));
    });
  }

  // The owner sees an "Owner admin" link in the workspace menu. is_admin() only
  // exists after 0005; any error just leaves the link hidden.
  function checkAdmin(){
    var link = document.getElementById("adminLink");
    if(!link) return;
    supabase.rpc("is_admin").then(function(r){ link.hidden = !(r && !r.error && r.data === true); }, function(){});
  }

  document.getElementById("authWaitRetry").addEventListener("click", function(){
    supabase.auth.getSession().then(function(res){
      if(res.data && res.data.session) boot(res.data.session); else showSignIn();
    });
  });
  document.getElementById("authWaitSignOut").addEventListener("click", function(){
    supabase.auth.signOut().then(function(){ window.location.reload(); });
  });

  document.getElementById("signOutBtn").addEventListener("click", function(){
    supabase.auth.signOut().then(function(){ window.location.reload(); });
  });

  showLoading();
  supabase.auth.getSession().then(function(res){
    if(res.data && res.data.session) boot(res.data.session);
    else if(wantsSignInDirectly()) showSignIn();
    else window.location.replace("/welcome");
  });

  supabase.auth.onAuthStateChange(function(event, session){
    if(event === "SIGNED_IN" && session) boot(session);
    else if(event === "SIGNED_OUT") window.location.reload();
  });
}
